import React from "react";
import { useNavigate } from "react-router-dom";

const LogoutSuccess = () => {
  const navigate = useNavigate();

  return (
    <div className="logout-success">
      <div className="success-content">
        <div className="success-icon">✓</div>
        <h2>Signed out of all devices successfully</h2>
        <p>If you'd like to sign back in, go to the landing page by clicking the button below.</p>

        <button
          onClick={() => navigate("/")}
          className="auth-button"
        >
          Go to landing page
        </button>
      </div>
    </div>
  );
};

export default LogoutSuccess;
